import React from "react";
import { Navigate } from "react-router-dom";

// Chat
import Chat from "../pages/Chat";

// CRM
import CrmCompanies from "../pages/Crm/CrmCompanies";
import CompanyWizard from "../pages/Crm/Companies/CompanyWizard";
import CrmIndividuals from "../pages/Crm/CrmIndividuals";
import IndividualWizard from "../pages/Crm/Individuals/IndividualWizard";

// Admin
import CheckListConfiguration from "../pages/Admin/CheckListConfiguration";

// Pages
import InDevelopment from "../pages/Pages/InDevelopment/InDevelopment";

// File Manager
import FileManager from "../pages/FileManager";

// Profile
import Settings from '../pages/Pages/Profile/Settings/Settings';

// User Profile
import UserProfile from "../pages/Authentication/user-profile";

// Login
import Login from "../pages/Authentication/Login";
import ForgetPasswordPage from "../pages/Authentication/ForgetPassword";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";
import TenantSignup from "../pages/Authentication/TenantSignup";

const authProtectedRoutes = [
  // Chat
  { path: "/apps-chat", component: <Chat /> },

  // CRM
  { path: "/apps-crm-clientes-acompanhamento", component: <InDevelopment /> },
  { path: "/apps-crm-companies", component: <CrmCompanies /> },
  { path: "/apps-crm-companies/new", component: <CompanyWizard /> },
  { path: "/apps-crm-companies/edit/:id", component: <CompanyWizard /> },
  { path: "/apps-crm-individuals", component: <CrmIndividuals /> },
  { path: "/apps-crm-individuals/new", component: <IndividualWizard /> },
  { path: "/apps-crm-individuals/edit/:id", component: <IndividualWizard /> },

  // File Manager
  { path: "/apps-file-manager", component: <FileManager /> },

  // Admin
  { path: "/admin-checklist-config", component: <CheckListConfiguration /> },

  // Profile
  { path: "/pages-profile-settings", component: <Settings /> },

  // User Profile
  { path: "/profile", component: <UserProfile /> },

  // Default route - redirect to chat
  {
    path: "/",
    exact: true,
    component: <Navigate to="/apps-chat" />,
  },
  { path: "*", component: <Navigate to="/apps-chat" /> },
];

const publicRoutes = [
  // Authentication Pages
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgetPasswordPage /> },
  { path: "/register", component: <Register /> },
  { path: "/tenant-signup", component: <TenantSignup /> },
];

export { authProtectedRoutes, publicRoutes };
